import { render, staticRenderFns } from "./RecordFormDialog.vue?vue&type=template&id=4f9ed5c6"
import script from "./RecordFormDialog.vue?vue&type=script&lang=js"
export * from "./RecordFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports